<template>
    <div class="container">
        <!-- <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="iconfont icon-xiangmuluyan"></i> 项目管理 </el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
        <div class="">
            <div class="handle-box" style="padding-left: 10px">
                <el-select v-model="query.searchTag" placeholder="地址" class="handle-select mr10">
                    <el-option key="1" label="项目ID" value="projectId"></el-option>
                    <el-option key="2" label="项目名称" value="projectName"></el-option>
                </el-select>
                <el-input v-model="query.searchValue" placeholder="请输入搜索内容" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-refresh-right" @click="resetSearch">重置</el-button>
            </div>

            <mscard class="projcetCard">
                <template v-slot:header>
                    <div class="cardTitle">项目列表</div>
                    <!-- <div class="cardTitle">企业列表 - {{ deviceListData[0].projectId }}</div> -->
                </template>
                <template v-slot:body>
                    <table class="projectStyle" cellspacing="0">
                        <tr class="projectHeader" style="text-align: center">
                            <th>项目ID</th>
                            <th>项目名称</th>
                            <th>设备类型</th>
                            <th>操作</th>
                        </tr>
                        <tr v-for="(item, index) in tableData" :key="index"
                            :class="selectDevice == index ? 'projectBody selcetBgc' : 'projectBody'"
                            style="text-align: center">
                            <td>{{ item.projectId }}</td>
                            <td>{{ item.projectName ? item.projectName : 'null' }}</td>
                            <td>{{ item.deviceType ? item.deviceType : 'null' }}</td>
                            <td class="moreDeviceDetail">
                                <el-button type="text" @click="editProjectName(index, item)">编辑名称</el-button>
                                <el-button type="text" @click="goProjectDevice(index, item)">查看设备</el-button>
                            </td>
                        </tr>
                    </table>
                </template>
            </mscard>

            <!-- <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="projectId" label="项目ID"></el-table-column>
                <el-table-column label="项目名称">
                    <template slot-scope="scope">{{ scope.row.projectName ? scope.row.projectName : 'null' }}</template>
                </el-table-column>
                <el-table-column label="设备类型">
                    <template slot-scope="scope">{{ scope.row.deviceType ? scope.row.deviceType : 'null' }}</template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="editProjectName(scope.$index, scope.row)">编辑名称</el-button>
                        <el-button type="text" @click="goProjectDevice(scope.$index, scope.row)">查看设备</el-button>
                    </template>
                </el-table-column>
            </el-table> -->
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
                    :page-size="query.pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>

        <el-dialog title="编辑" :visible.sync="editVisible" width="30%">
            <el-input v-model="editProjectNameVale"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEditProjectName">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { QueryProjectList, UpdateProjectName } from '../../api/index';
import mscard from '@/components/common/dashBoard/msCard.vue';
import moment from 'moment';
export default {
    name: 'basetable',
    data() {
        return {
            // 编辑项目名称值
            editProjectNameVale: '',
            editProjectID: '',

            query: {
                searchTag: 'projectId',
                searchValue: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1
        };
    },
    created() {
        this.getData();
    },
    methods: {
        // 重置搜索条件
        resetSearch() {
            this.query = {
                searchTag: 'projectId',
                searchValue: '',
                pageIndex: 1,
                pageSize: 10
            };
            this.getData();
        },
        async getData() {
            const { data } = await QueryProjectList({
                searchTag: this.query.searchTag,
                searchValue: this.query.searchValue ? this.query.searchValue : '%',
                limit: this.query.pageSize,
                offset: this.query.pageIndex - 1
            });
            console.log(data);
            this.pageTotal = data.count;
            let dataArr = [];
            data.rows.forEach((item) => {
                let obj = item;
                dataArr.push(obj);
            });
            this.tableData = dataArr;
        },

        // 打开编辑弹窗
        async editProjectName(index, row) {
            this.editVisible = true;
            console.log(row);
            this.editProjectNameVale = row.projectName;
            this.editProjectID = row.id;
            console.log(this.editProjectNameVale);
        },
        // 保存编辑值
        async saveEditProjectName() {
            const result = await UpdateProjectName({
                projectId: this.editProjectID,
                projectName: this.editProjectNameVale
            });
            this.$message.success('修改成功');
            this.editVisible = false;
            this.getData();
        },

        // 跳转项目设备详情
        async goProjectDevice(index, row) {
            this.$router.push(`AProjectDevice?projectId=${row.projectId}`);
        },

        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.$message.success('删除成功');
                    this.tableData.splice(index, 1);
                })
                .catch(() => { });
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.form = row;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    },
    components: {
        mscard
    }
};
</script>

<style scoped lang="less">
@import '../../assets/css/variables.less';

// 修改弹窗样式 ---开始--
/deep/ .el-dialog__header {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-dialog__title {
    color: #fff;
}

/deep/ .el-dialog__body {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-dialog__footer {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-table th {
    background-color: @black-two !important;
    color: @gray-one;
}

/deep/ .el-table tr {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-table tr:hover {
    background: @black-three !important;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background: none;
}

/deep/ .el-table__empty-block {
    background-color: @black-two;

    border: none;
}

/deep/ .el-table__empty-text {
    color: #fff;
}

/deep/ .el-button--text {
    color: @gray-one;
}

/deep/ .el-button--text:hover {
    color: #fff;
}

/deep/ .el-button--primary {
    background-color: @black-three;
    color: #fff;
    border: none;
    transition: all 0.5s;
}

/deep/ .el-button--primary:hover {
    background-color: #fff;
    color: @black-three;
    border: none;
}

/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
    color: #fff;
}

/deep/ .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border: none !important;
}

// 修改弹窗样式 ---结束--

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
